<div class="btn" q9Track="TOOLBAR.HELP" [matMenuTriggerFor]="helpMenu">
  {{ 'TOOLBAR.HELP' | translate }}
</div>

<mat-menu #helpMenu="matMenu" xPosition="before" class="help-menu-container">
  <div class="help-commands-list">
    <div>
      <div *ngFor="let hint of helpList$ | async | keyvalue: keepOrder" class="hint-item">
        <span class="hint-name">{{ hint.key }}</span>
        {{ hint.value }}
      </div>
    </div>

    <div *ngIf="(activityStyle$ | async).infoStyle as infoStyle" class="paperclip-hint">
      <mat-icon
        class="attachment-icon"
        [ngStyle]="{
          color: infoStyle.iconColor,
          'background-color': infoStyle.backgroundColor,
          'border-radius': infoStyle.squared ? '' : '50%'
        }"
        [ngClass]="{'paperclip-icon': infoStyle.icon === 'icon-paperclip'}"
        [svgIcon]="infoStyle.icon"></mat-icon>
      <p class="paperclip-description">{{ 'HELP_MENU.PAPERCLIP_DESCRIPTION' | translate }}</p>
    </div>

    <div class="drildown-hint">
      <div
        class="drilldown"
        [ngStyle]="{'border-left-color': (activityStyle$ | async).borderColor}">
        <p class="drilldown-number">1</p>
      </div>
      <p class="drilldown-description">
        {{ 'HELP_MENU.DRILLDOWN_DESCRIPTION' | translate }}
      </p>
    </div>
  </div>

  <ng-container *ngIf="!(isStripped$ | async)">
    <div class="menu-separator"></div>
    <a class="help-link" (click)="goToSupport()">
      {{ 'HELP_MENU.GO_TO_SUPPORT' | translate }}
    </a>
  </ng-container>
</mat-menu>
